import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

export default (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 14" {...props}>
    {/* eslint-disable-next-line max-len */}
    <path d="M11 3h4a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2zM6 1v2h4V1H6zm0 6v3h4V7H6z" />
  </SvgIcon>
);
